import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  ADMIN,
  ADMIN_USER,
  APPROVAL_APPROVED_ACL,
  APPROVAL_DEACTIVATED_ACL,
  APPROVAL_LIST,
  APPROVAL_PENDING_ACL,
  APPROVAL_REJECTED_ACL,
  DASHBOARD_APPROVAL_ACL,
  FINANCE,
  OPERATIONS,
  PENDING,
  REJECTED,
  RNC,
  RNCAPPROVED,
  RNCPENDING,
  RNCREJECTED,
  SALES,
  SUPPORT
} from "../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomTabs from "../../../components/main_comps/custom_tabs";
import MainComponent from "../../../components/ui_comps/MainComponent";
import Approved from "./Approved";
import DeactivatedAccount from "./DeactivatedAccount";
import PendingApproval from "./PendingApproval";
import RejectedApproval from "./RejectedApproval";
import Sid from "./SalesTeam/Sid";

const tabs = [
  { name: "Pending Approval", key: 0, aclValue: APPROVAL_PENDING_ACL },
  { name: "RNC Pending", key: 1, aclValue: APPROVAL_APPROVED_ACL },
  { name: "Rejected Approval", key: 2, aclValue: APPROVAL_REJECTED_ACL },
  { name: "Rejected by RNC", key: 3, aclValue: APPROVAL_REJECTED_ACL },
  { name: "Deactivated Account", key: 4, aclValue: APPROVAL_DEACTIVATED_ACL }
];
const operationTabs = [
  { name: "Pending Approval", key: 0, aclValue: APPROVAL_PENDING_ACL },
  { name: "RNC Pending", key: 1, aclValue: APPROVAL_APPROVED_ACL },
  { name: "Rejected Approval", key: 2, aclValue: APPROVAL_REJECTED_ACL },
  { name: "Rejected by RNC", key: 3, aclValue: APPROVAL_REJECTED_ACL },
  { name: "Deactivated Account", key: 4, aclValue: APPROVAL_DEACTIVATED_ACL },
  { name: "Enter SID", key: 5 }
];
const rncTab = [
  { name: "Pending Approval", key: 0, aclValue: APPROVAL_PENDING_ACL },
  { name: "Rejected Approval", key: 1, aclValue: APPROVAL_REJECTED_ACL },
  { name: "Approved by RNC", key: 2, aclValue: APPROVAL_APPROVED_ACL }
];
const salesTab = [
  { name: "Pending Approval by RNC", key: 0 },

  { name: "Enter SID", key: 1 },
  {
    name: "Pending Approval from Admin",
    key: 2
  },
  { name: "Rejected Clients", key: 3 },
  { name: "RNC Rejected Clients", key: 4 }
];

function ApprovalMainIndex() {
  const [currentTab, setCurrentTab] = useState(0);
  const [onClickViewMore, setOnClickViewMore] = useState(false);
  const [clientData, setClientData] = useState({});
  const [tab, setTab] = useState([]);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  console.log(aclData, "ACL DATA");
  const navigate = useNavigate();
  const role = secureStorage.getItem(SS_ROLE);

  useEffect(() => {
    if (role === RNC) {
      setTab(rncTab);
    } else if (role === SALES) {
      setTab(salesTab);
    } else if (role === OPERATIONS) {
      setTab(operationTabs);
    } else {
      setTab(tabs);
    }
  }, [role]);

  useEffect(() => {
    console.log(tab, "Tabs");
  }, [tab]);
  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white"
      }}
    >
      <MainComponent
        notificationRequired={false}
        headerTitle="Approval"
        filterRequired={false}
      />{" "}
      <CustomTabs
        tabs={tab}
        activeIndex={currentTab}
        passCurrentTab={(tab) => setCurrentTab(tab)}
        // actionComponent={
        //   <ActionComponent onClick={() => setShowDownloadModal(true)} />
        // }
      />
      {role === ADMIN ||
      role === ADMIN_USER ||
      role === SUPPORT ||
      role === FINANCE ? (
        currentTab === 0 ? (
          <PendingApproval
            status={PENDING}
            aclList={aclData}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);
              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: PENDING
                }
              });
            }}
          />
        ) : currentTab === 1 ? (
          <PendingApproval
            status={RNCPENDING}
            aclList={aclData}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCPENDING
                }
              });
            }}
          />
        ) : currentTab === 2 ? (
          <RejectedApproval
            status={REJECTED}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);
              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: REJECTED
                }
              });
            }}
          />
        ) : currentTab === 3 ? (
          <RejectedApproval
            status={RNCREJECTED}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCREJECTED
                }
              });
            }}
          />
        ) : currentTab === 4 ? (
          <DeactivatedAccount />
        ) : null
      ) : role === RNC ? (
        currentTab === 0 ? (
          <PendingApproval
            aclList={aclData}
            status={RNCPENDING}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCPENDING
                }
              });
            }}
          />
        ) : currentTab === 1 ? (
          <RejectedApproval
            status={RNCREJECTED}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCREJECTED
                }
              });
            }}
          />
        ) : (
          <Approved
            status={RNCAPPROVED}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCAPPROVED
                }
              });
            }}
          />
        )
      ) : role === SALES ? (
        currentTab === 0 ? (
          <PendingApproval
            status={RNCPENDING}
            aclList={aclData}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCPENDING
                }
              });
            }}
          />
        ) : currentTab == 1 ? (
          <Sid
            onChange={(val) => {
              setOnClickViewMore(val);
            }}
            clientData={clientData}
          />
        ) : currentTab === 2 ? (
          <PendingApproval
            status={PENDING}
            aclList={aclData}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: PENDING
                }
              });
            }}
          />
        ) : currentTab === 3 ? (
          <RejectedApproval
            status={REJECTED}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: REJECTED
                }
              });
            }}
          />
        ) : currentTab === 4 ? (
          <RejectedApproval
            status={RNCREJECTED}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCREJECTED
                }
              });
            }}
          />
        ) : (
          ""
        )
      ) : role === OPERATIONS ? (
        currentTab === 0 ? (
          <PendingApproval
            status={PENDING}
            aclList={aclData}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);
              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: PENDING
                }
              });
            }}
          />
        ) : currentTab === 1 ? (
          <PendingApproval
            status={RNCPENDING}
            aclList={aclData}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCPENDING
                }
              });
            }}
          />
        ) : currentTab === 2 ? (
          <RejectedApproval
            status={REJECTED}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);
              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: REJECTED
                }
              });
            }}
          />
        ) : currentTab === 3 ? (
          <RejectedApproval
            status={RNCREJECTED}
            onChange={(val, clientData) => {
              setOnClickViewMore(val);

              navigate("/approval/list/details", {
                state: {
                  clientData,
                  status: RNCREJECTED
                }
              });
            }}
          />
        ) : currentTab === 4 ? (
          <DeactivatedAccount />
        ) : currentTab === 5 ? (
          <Sid
            onChange={(val) => {
              setOnClickViewMore(val);
            }}
            clientData={clientData}
          />
        ) : null
      ) : (
        <></>
      )}
    </div>
  );
}

export default ApprovalMainIndex;
